import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Button from '../../../juristec-ui/core/Button';
import { CustomProviderProps } from '../types';

import {
  FormFieldSet,
  FormField,
} from '../styled';

const CustomProvider = ({
  setProviderId, providerLogin, t, goBack,
}: CustomProviderProps) => {
  const { provider } = useParams<{ provider?: string }>();

  useEffect(() => {
    if (!provider) goBack();
    else setProviderId(provider);
  }, [provider]);

  return (
    <FormFieldSet>
      <h2>{t('loginTitle')}</h2>
      <FormField>
        <Button
          type="submit"
          onClick={providerLogin}
          textTransform="none"
          color="primary"
          size="large"
          style={{ width: '100%', margin: '20px 0 10px 0' }}
        >
          {t('enterSSOBtn')}
        </Button>
      </FormField>
    </FormFieldSet>
  );
};

export default CustomProvider;
